import { InjectionToken, TemplateRef, Type } from "@angular/core";

import { ModalTemplateContext } from "@lantern/app/common/utils/modals/modal-template.directive";
import { ModalComponent } from "@lantern/app/common/utils/modals/modal.component";

export const MODAL_COMPONENT_TYPE: InjectionToken<Type<ModalComponent<any>>> =
  new InjectionToken("MODAL_COMPONENT_TYPE");

export interface ModalTemplateOptions<Response> {
  templateRef: TemplateRef<ModalTemplateContext<Response>>;
  context: ModalTemplateContext<Response>;
}
export const MODAL_TEMPLATE_OPTIONS: InjectionToken<ModalTemplateOptions<any>> =
  new InjectionToken("MODAL_TEMPLATE_OPTIONS");
